import dynamic from "next/dynamic";

export const DynamicContent006 = dynamic(() => import("./Content006"), {
  suspense: true,
});
